var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.603,
    height: 85.467,
    viewBox: "0 0 85.603 85.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2376",
    "data-name": "Group 2376",
    transform: "translate(-1647.305 -367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5141",
    "data-name": "Path 5141",
    d: "M68.884,71.321a9.1,9.1,0,1,0-5.007,8.1l5.395,5.4a3.037,3.037,0,1,0,4.295-4.3l-5.485-5.485A9.012,9.012,0,0,0,68.884,71.321Zm-9.069,7.436a7.436,7.436,0,1,1,7.435-7.436A7.445,7.445,0,0,1,59.815,78.757Zm12.6,2.916a1.408,1.408,0,0,1,0,1.985,1.44,1.44,0,0,1-1.987,0L65.3,78.528A9.118,9.118,0,0,0,67.245,76.5Z",
    transform: "translate(1630.546 337.859)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5142",
    "data-name": "Path 5142",
    d: "M73.022,81.25V26.709L61.064,14.75H26.537L22.9,22.72,26.2,29.94,22.9,37.159,26.2,44.378,22.9,51.6,26.2,58.824,22.9,66.046,26.2,73.273,22.563,81.25H73.022ZM61.5,17.311l8.958,8.958H61.5ZM24.552,66.047l3.292-7.222L24.552,51.6l3.292-7.222L24.552,37.16l3.292-7.219-3.292-7.22,2.95-6.47H60V27.77H71.523V79.75H24.893l2.95-6.477Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5143",
    "data-name": "Path 5143",
    d: "M30.471,88.492a2.242,2.242,0,1,0-2.242,2.242A2.245,2.245,0,0,0,30.471,88.492Zm-3.985,0a1.742,1.742,0,1,1,1.742,1.742A1.745,1.745,0,0,1,26.486,88.492Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5144",
    "data-name": "Path 5144",
    d: "M8.512,27.812,7.521,29.82,5.3,30.142l1.6,1.563L6.53,33.912,8.512,32.87l1.982,1.042L10.116,31.7l1.6-1.563L9.5,29.82ZM9.579,31.53,9.83,33l-1.318-.692L7.194,33l.251-1.468L6.379,30.49l1.474-.214.659-1.335.659,1.335,1.474.214Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5145",
    "data-name": "Path 5145",
    d: "M26.923,11.03l1.368-.719,1.368.719L29.4,9.507l1.107-1.079L28.975,8.2l-.684-1.386L27.607,8.2l-1.53.223,1.107,1.079Zm.229-2.254.788-.114.352-.713.352.713.788.114-.57.556.134.784-.7-.37-.7.37.134-.784Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5146",
    "data-name": "Path 5146",
    d: "M84.873,68.067l1.107,1.079-.261,1.523,1.368-.719,1.368.719-.261-1.523L89.3,68.067l-1.53-.223-.684-1.386L86.4,67.844Zm2.214-.479.352.713.788.114-.57.556.134.784-.7-.37-.7.37.134-.784-.57-.556.788-.114Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5147",
    "data-name": "Path 5147",
    d: "M87.087,14.135l-.9,2.777H83.266l2.361,1.717-.9,2.776,2.362-1.716,2.362,1.716-.9-2.776,2.361-1.717H87.989Zm.872,4.3L88.5,20.1l-1.411-1.025L85.676,20.1l.539-1.658L84.8,17.412h1.745l.539-1.659.539,1.659h1.745Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5148",
    "data-name": "Path 5148",
    d: "M79.131,9.751a2.242,2.242,0,1,0-2.242-2.242A2.245,2.245,0,0,0,79.131,9.751Zm0-3.984a1.742,1.742,0,1,1-1.742,1.742A1.745,1.745,0,0,1,79.131,5.767Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5149",
    "data-name": "Path 5149",
    d: "M86.837,48.986A1.786,1.786,0,1,0,88.623,47.2,1.788,1.788,0,0,0,86.837,48.986ZM88.623,47.7a1.286,1.286,0,1,1-1.286,1.286A1.288,1.288,0,0,1,88.623,47.7Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5150",
    "data-name": "Path 5150",
    d: "M14.958,19.516A2.361,2.361,0,1,0,12.6,17.155,2.363,2.363,0,0,0,14.958,19.516Zm0-4.222A1.861,1.861,0,1,1,13.1,17.155,1.863,1.863,0,0,1,14.958,15.294Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5151",
    "data-name": "Path 5151",
    d: "M23.07,88.247c-.325-.065-.646-.138-.964-.217l-.122.484c.326.083.655.156.988.223Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5152",
    "data-name": "Path 5152",
    d: "M9.958,79l-.428.256c.339.567.711,1.124,1.1,1.655l.4-.3C10.652,80.093,10.29,79.55,9.958,79Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5153",
    "data-name": "Path 5153",
    d: "M20.248,87.464c-.607-.217-1.21-.468-1.793-.744l-.214.452c.6.283,1.216.54,1.838.763Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5154",
    "data-name": "Path 5154",
    d: "M16.743,85.8c-.551-.331-1.093-.695-1.612-1.081l-.3.4c.532.4,1.088.769,1.653,1.108Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5155",
    "data-name": "Path 5155",
    d: "M13.634,83.488c-.478-.435-.939-.9-1.37-1.375l-.371.335c.441.49.914.964,1.4,1.41Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5156",
    "data-name": "Path 5156",
    d: "M6.864,71.81c.1.653.228,1.309.388,1.95l.485-.122c-.157-.625-.285-1.265-.379-1.9Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5157",
    "data-name": "Path 5157",
    d: "M6.646,68.852q0,.492.024.98l.5-.024q-.022-.476-.023-.956t.024-.985l-.5-.024C6.654,68.18,6.646,68.517,6.646,68.852Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5158",
    "data-name": "Path 5158",
    d: "M9.044,77.286C8.767,76.7,8.517,76.1,8.3,75.494l-.471.169c.222.619.479,1.237.762,1.837Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5159",
    "data-name": "Path 5159",
    d: "M6.87,65.849l.494.073q.072-.486.17-.973l-.49-.1C6.977,65.184,6.919,65.516,6.87,65.849Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5160",
    "data-name": "Path 5160",
    d: "M89.737,76.011l-.5-.01q-.011.5-.055.981l.5.046C89.711,76.692,89.73,76.354,89.737,76.011Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5161",
    "data-name": "Path 5161",
    d: "M78.524,88.985l.1.489a13.98,13.98,0,0,0,2.131-.636l-.181-.466A13.313,13.313,0,0,1,78.524,88.985Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5162",
    "data-name": "Path 5162",
    d: "M86.192,85.063a14.282,14.282,0,0,0,1.342-1.773l-.421-.27a13.717,13.717,0,0,1-1.295,1.71Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5163",
    "data-name": "Path 5163",
    d: "M84.271,86.217a13.667,13.667,0,0,1-1.76,1.225l.252.432a14.079,14.079,0,0,0,1.826-1.27Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5164",
    "data-name": "Path 5164",
    d: "M88.121,81.128l.459.2a13.964,13.964,0,0,0,.721-2.1l-.484-.124A13.457,13.457,0,0,1,88.121,81.128Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5165",
    "data-name": "Path 5165",
    d: "M76.417,89.764l-.025-.5c-.325.017-.651.024-.983.015l-.01.5.288,0C75.931,89.783,76.175,89.777,76.417,89.764Z",
    transform: "translate(1642 361.733)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2468",
    "data-name": "Rectangle 2468",
    width: 0.5,
    height: 2,
    transform: "translate(1730.373 390.11)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2469",
    "data-name": "Rectangle 2469",
    width: 0.5,
    height: 2,
    transform: "translate(1730.373 394.11)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2470",
    "data-name": "Rectangle 2470",
    width: 0.5,
    height: 2,
    transform: "translate(1730.373 398.11)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2471",
    "data-name": "Rectangle 2471",
    width: 0.5,
    height: 2,
    transform: "translate(1730.373 402.11)",
    fill: "#dde4eb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyData);
export default __webpack_public_path__ + "static/media/empty-data.7f868fea.svg";
export { ForwardRef as ReactComponent };